import { CommandDeparture, CostBasis } from './types';

export const breakEvenUnavailableTooltip =
  'An unavailable break-even means missing price, cost or supplier curve, or no reachable group size covers cost.';

export function breakEvenText(departure: CommandDeparture, basis: CostBasis): string {
  const breakeven = departure[`breakeven_pax_${basis}`];
  if (breakeven == null) return 'Break-even —';
  const short = breakeven - Math.round(departure.pred_pax);
  return `Break-even ${breakeven.toLocaleString('en-AU')}${short > 0 ? ` · ${short.toLocaleString('en-AU')} short` : ''}`;
}
